import { IFieldInstance } from "../../types/fieldInstance.interface";

export const convertToValidRSOption = (options: any[]) => {
  return options.map((option) => {
    return { label: option, value: option };
  });
};

export function formatRadioButtonOptions(
  obj: IFieldInstance,
  fetchedOptions: any[] | undefined
): any[] {
  const values = fetchedOptions || obj.values;
  if (!obj.values) return [];
  if (
    !obj.values.length ||
    !obj.valueLabels?.length ||
    obj.values.length !== obj.valueLabels.length ||
    (fetchedOptions && fetchedOptions?.length !== obj.valueLabels.length)
  ) {
    return values;
  }
  return values.map((val, index) => {
    return {
      label: obj.valueLabels[index],
      value: val,
    };
  });
}
